import React from "react";
import { IResolveParams } from "reactjs-social-login";
import ScrollableContainer from "./ScrollableContainer";
import BackButton from "./BackButton";
import SocialAuth from "../../pages/lmcUserVIew/SocialAuth";
import { CustomButton } from "../CustomButton";
import LanguageSelector from "../LanguageSelector";

interface AuthViewProps {
  onBack: () => void;
  onShowEmailAuth: () => void;
  onResolveSocialAuth: (
    provider: IResolveParams["provider"],
    data: IResolveParams["data"]
  ) => void;
  onRejectSocialAuth: (err: any) => void;
  t: (key: string, options?: Record<string, unknown>) => string;
}

const AuthView: React.FC<AuthViewProps> = ({
  onBack,
  onShowEmailAuth,
  onResolveSocialAuth,
  onRejectSocialAuth,
  t,
}) => (
  <ScrollableContainer>
    <div className="flex items-start justify-between gap-2">
      <div>
        <h2 className="text-lg font-semibold text-white">
          {t("event.auth.title")}
        </h2>
      </div>
      <div className="flex items-center gap-2">
        <BackButton onClick={onBack} label={t("event.auth.backToTickets")} />
        <LanguageSelector variant="compact" />
      </div>
    </div>

    <div className="w-full flex-col justify-between items-center flex">
      <SocialAuth
        className="w-full"
        providers={["Google", "Apple"]}
        onLoginStartSocialAuthStart={() => {}}
        onResolveSocialAuth={onResolveSocialAuth}
        onRejectSocialAuth={onRejectSocialAuth}
        redirectUrl={{
          Apple: `${process.env.REACT_APP_APPLE_CALLBACK}`,
        }}
        providersIcon={{
          Apple: (
            <div className="bg-gray-700 hover:bg-gray-600 rounded-xl px-4 w-full h-11 flex flex-row justify-center items-center cursor-pointer relative border border-gray-600 transition-all duration-200 shadow-sm">
              <img
                src="../../images/apple.svg"
                alt=""
                className="w-5 h-5 absolute left-4"
              />
              <p className="text-white text-sm font-semibold font-figtree leading-normal">
                {t("key18")}
              </p>
            </div>
          ),
          Google: (
            <div className="bg-gray-700 hover:bg-gray-600 rounded-xl px-4 w-full h-11 flex flex-row justify-center items-center cursor-pointer relative border border-gray-600 transition-all duration-200 shadow-sm">
              <img
                src="../../images/google.svg"
                alt=""
                className="w-5 h-5 absolute left-4"
              />
              <p className="text-white text-sm font-semibold font-figtree leading-normal">
                {t("key19")}
              </p>
            </div>
          ),
        }}
      />
    </div>

    <div className="flex items-center gap-4">
      <div className="flex-1 h-px bg-white/20"></div>
      <p className="text-center text-white/70 text-xs font-medium uppercase leading-none">
        {t("key20")}
      </p>
      <div className="flex-1 h-px bg-white/20"></div>
    </div>

    <CustomButton
      variant="primary"
      className="w-full bg-blue-500 text-white enabled:hover:bg-blue-600"
      title={t("key25") as string}
      onClick={onShowEmailAuth}
    />
  </ScrollableContainer>
);

export default AuthView;
